import React from "react";
import styled, { keyframes } from "styled-components";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #e6e6e6;
  border-top-color: #2eccff;
  border-radius: 50%;
  animation: ${spin} 0.9s linear infinite;
`;

const Loader: React.FC = () => (
  <Wrapper>
    <Spinner aria-label="Loading" role="status" />
  </Wrapper>
);

export default Loader;
